import { useTranslation } from "react-i18next";
import { chatDeleteSessionMutation, chatListSessionsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for the open chat. */
export function useDeleteChat(onDeleted: () => void) {
  const { t } = useTranslation("chat", { keyPrefix: "header" });
  return useDeleteEntity({
    mutation: chatDeleteSessionMutation(),
    listQueryKey: () => chatListSessionsQueryKey(),
    pathFor: (chat) => ({ session_uuid: chat.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
